import withProgress from 'core/components/progress/withProgress'
import Dropdown from 'core/elements/dropdown'
import useListAction from 'core/hooks/useListAction'
import { listNetworks } from 'openstack/components/networks/actions'
import {
  networksByIdSelector,
  subnetsFromAllNetworksSelector,
} from 'openstack/components/networks/selectors'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

export default function SubnetPicklist({
  disabled = false,
  name = 'subnet',
  label = 'Subnet',
  networkId = null,
  includeNoneOption = false,
  ...rest
}) {
  const { loading } = useListAction(listNetworks)
  const networksById = useSelector(networksByIdSelector)
  const subnets = useSelector(subnetsFromAllNetworksSelector)

  const networkSubnets = useMemo(() => {
    if (!networkId) {
      return subnets
    }
    return networksById[networkId]?.subnetDetails || []
  }, [networkId, subnets])

  const options = useMemo(() => {
    // will need to filter out taken private IPs
    const subnetOptions = networkSubnets.map((subnet) => {
      const network = networksById[subnet.network_id]
      const subnetLabel = `${network?.name || network?.id}: ${subnet?.cidr} (${subnet?.name ||
        subnet?.id})`
      const portAndIpsAvailable = network?.availablePortAndIPs > 0
      return {
        label: subnetLabel,
        value: subnet,
        disabled: !portAndIpsAvailable,
        tooltip: !portAndIpsAvailable ? 'Network has no available IP addresses or ports' : null,
      }
    })

    if (subnetOptions?.length === 0 && !includeNoneOption) {
      return [{ label: 'No subnets available', value: null }]
    }

    return includeNoneOption ? [{ label: 'None', value: null }, ...subnetOptions] : subnetOptions
  }, [networksById, networkSubnets, includeNoneOption])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading}
      items={options}
    />
  )
}
